import React from "react";
import Dropzone from "react-dropzone";
import { translate } from "../../utils/useful";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import { nanoid } from "nanoid";
import HttpServices from "../../utils/Http.services";

class Uploader extends React.Component {
	constructor() {
		super();
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.state = {
			// uploadingList: false,
			uploadList: []
			// paths: [{ name: 'Drive', _id: null }],
		};
	}

	promises = []
	uploadedCount = 0

	componentDidMount() {
		// console.log('currentAppletcurrentApplet', this.props.applet)
	}

	handleSubmit(evt) {
		evt.preventDefault();
	}

	handleInputChange(files) {
		console.log("handleInputChange")
		let paths = this.props.paths
		let uploadList = this.state.uploadList ?? []
		uploadList = [...uploadList, ...files]

		console.log(uploadList, files)

		this.setState({ uploadList });
		// console.log('paths', { folder: paths[paths.length - 1]._id, type: 'drive', drive: '123', applet: this.props.applet, frame: this.props.page?._id })
		// return
		files.forEach(file => {

			// this.promises.push(new Promise((resolve, reject) => {

			HttpServices.addUploadQueque(file, { folder: paths[paths.length - 1]?._id, type: 'drive', drive: '123', applet: this.props.applet, frame: this.props.page?._id }, nanoid(), (fetchResult, fetchError) => {

				this.uploadedCount++
				// console.log(fetchResult, fetchError, uploadList)
				// resolve()
				// this.props.getFiles()
				this.checkList()
				// this.props.hideUploadModal()
			})
			// }))
		});
	}

	checkList = () => {

		// Promise.all(this.promises).then(() => {
		// 	console.log("FINAL")
		// 	this.props.getFiles()
		// 	this.props.hideUploadModal()
		// })
		if (this.uploadedCount >= this.state.uploadList?.length) {
			this.props.hideUploadModal()
			this.props.getFiles()
		}

	}

	render() {
		return (
			<div className="" onSubmit={this.handleSubmit}>
				<div className="flexcc" style={{ cursor: 'pointer' }}>
					<Dropzone ref={el => this.dropzoneRef = el} multiple={true} onDrop={(e) => this.handleInputChange(e, false)} style={{ flex: 1, cursor: 'pointer', outline: 'none' }}>
						{({ getRootProps, getInputProps }) => (
							<div className=" w-100 h-100 outline-none flexcc p-3 " {...getRootProps()} onDragLeave={this.onDragLeave} style={{ backgroundColor: '#fff', maxHeight: '500px', maxWidth: '500px' }}>
								<input {...getInputProps()} />
								<div className="w-100 h-100 flexcc flex-column py-4" style={{ border: '2px dashed #DDCFE6', borderRadius: 8, pointerEvents: 'none' }}>
									<div className="flexcc mb-3" width={100} height={100} style={{ backgroundColor: 'rgb(255 246 233)', borderRadius: '300px', width: '110px', height: '110px' }}>
										<div style={{ position: 'relative' }}>
											<img className="p-2" style={{}} src={'/assets/icons/applets/drive/drive-folder.svg'} draggable={false} width={80} />
											<div className="flexcc" style={{ position: 'absolute', top: '50px', left: '45px', backgroundColor: '#fff', borderRadius: '100px' }}>
												<img className="m-1 flexcc" src={'/assets/icons/applets/drive/arrow.up.orange.svg'} width={20} draggable={false} />
											</div>
										</div>
									</div>
									<div className="flexcc" style={{ maxWidth: '200px', textAlign: 'center' }}>
										<p className="text-semibold font-size-15 " style={{ color: '#444' }}>{translate("drives.Drag & drop your files here or")}&nbsp;<span onClick={() => this.createDirectory()} className="font-size-15 cursor-pointer" style={{ color: this.props.colors ? this.props.colors.primaryColor : '#222' }}>{translate("drives.choose file")}</span></p>
									</div>
								</div>
							</div>
						)}
					</Dropzone>
				</div>
				<div className="">
					{this.props.queque?.uploads?.map((item, index) => {
						return (
							<div>
								<div className="uploaded-files-list p-3 scroll-no-scrollbar" style={{ display: "flex", flexDirection: "column", overflowY: "scroll" }}>
									<div>
										<span className="choosed-file">
											<div className="pb-2">
												{item?.file?.name}
											</div>
											<div className=' flexc br-10' style={{ background: 'rgba(239, 239, 239,0.5)', height: '10px' }}>
												<div className=" br-10" style={{ background: this.props.colors ? this.props.colors.background : '#FF9500', width: `${item.precentage}%`, height: '10px' }}>
												</div>
											</div>
										</span>
										<div className="value">
											<div style={{ color: "black", fontSize: "11px" }}>
												<span >{item.precentage ? item.precentage.toFixed(0) : 0}%</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						)
					})}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, queque: state.queque })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Uploader);
